import { TableCell } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled(TableCell)`
  transition: 3ms;
  background: #fff;
  position: absolute;
  right: 0;
  margin-right: 4rem;
  margin-top: 1px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 999;
  padding: 1.2rem 2rem !important;
  border: transparent;

  button {
    margin: 0 0.5rem;
  }

  svg {
    font-size: 2rem;

    :hover {
      color: #000;
    }
  }
`;
